import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_gray_60.png'


const _withScopeId = n => (_pushScopeId("data-v-985d34a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "modal-icon",
  src: _imports_0
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "invite-header" }
const _hoisted_9 = { class: "invite-header-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "From", -1))
const _hoisted_11 = { class: "invite-header-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "To", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "invite-header-item"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Sent", -1))
const _hoisted_17 = { class: "invite-date" }
const _hoisted_18 = {
  key: 1,
  class: "invite-header-item"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Expires", -1))
const _hoisted_20 = { class: "invite-date" }
const _hoisted_21 = {
  key: 2,
  class: "invite-header-item"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Status", -1))
const _hoisted_23 = {
  key: 3,
  class: "invite-header-item"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Approved", -1))
const _hoisted_25 = { class: "invite-date" }
const _hoisted_26 = {
  key: 0,
  class: "alert alert-primary"
}
const _hoisted_27 = {
  key: 2,
  class: "invite-body"
}
const _hoisted_28 = {
  key: 0,
  class: "data-group"
}
const _hoisted_29 = {
  key: 1,
  class: "data-group"
}
const _hoisted_30 = { class: "family-group" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 2,
  class: "message"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Message", -1))
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "modal-footer" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  type: "button",
  class: "btn btn-outline-primary",
  "data-bs-dismiss": "modal"
}

import { computed, ref, watchEffect } from 'vue'
import { useDataGroupInviteStore } from '@/gp/DataGroupInviteStore'
import { useUserStore } from '@/gp/UserStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { ApprovalStatus, DataGroupInvite, DataGroupInviteStatus, DataGroupType, InvitationResult, PrincipalType } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { useTokenManager } from '@/auth/TokenManager'
import { CheckIcon, SendIcon, Trash2Icon } from '@zhuowenli/vue-feather-icons'
import { Modal } from 'bootstrap'
import { DateTime, Duration } from 'luxon'
import { useModalAutoHide } from '@/util/AppUtil'
import ProfileCard from '@/manage/ProfileCard.vue'
import ResearchGroupCard from '@/manage/researchgroups/ResearchGroupCard.vue'
import FamilyGroupItem from '@/manage/familygroups/FamilyGroupItem.vue'
import Spinner from '@/util/Spinner.vue'
import LoadingIndicator from '@/util/LoadingIndicator.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataGroupInviteModal',
  setup(__props, { expose: __expose }) {

const minResendInterval = Duration.fromObject({ days: 3 })

const inviteRef = ref<DataGroupInvite>()
const senderMessageRef = ref('')
const busyRef = ref(false)
const modalElemRef = ref<InstanceType<typeof HTMLElement>>()

const inviteStore = useDataGroupInviteStore()
const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()
const familyGroupStore = useFamilyGroupStore()
const tokenManager = useTokenManager()

useModalAutoHide(modalElemRef)

const isNewRef = computed(() => !inviteRef.value?.id)
const senderUserRef = computed(() => userStore.getAsyncUser(inviteRef.value?.senderUserId, LoadMode.EnsureLoaded)?.data)
const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(inviteRef.value?.dataGroupId, LoadMode.EnsureLoaded)?.data)
const dataGroupOwnerRef = computed(() => userStore.getAsyncUser(dataGroupRef.value?.ownerId, LoadMode.EnsureLoaded)?.data)
const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(inviteRef.value?.principalId, LoadMode.EnsureLoaded)?.data)
const familyGroupOwnerRef = computed(() => userStore.getAsyncUser(familyGroupRef.value?.ownerId, LoadMode.EnsureLoaded)?.data)

const loadingRef = computed(() => !inviteRef.value || !dataGroupOwnerRef.value || !familyGroupOwnerRef.value)
const titleRef = computed(() => isProfileRef.value ? "Profile sharing request" : "Tree sharing request")
const isProfileRef = computed(() => dataGroupRef.value?.groupType == DataGroupType.Profile)
const isSenderRef = computed(() => inviteRef.value?.senderUserId == tokenManager.current.userId)
const isDataGroupOwnerRef = computed(() => dataGroupRef.value?.ownerId == tokenManager.current.userId)
const isFamilyGroupOwnerRef = computed(() => familyGroupRef.value?.ownerId == tokenManager.current.userId)
const isDataGroupApprovedRef = computed(() => inviteRef.value?.dataGroupApproval == ApprovalStatus.Approved)
const isPrincipalApprovedRef = computed(() => inviteRef.value?.principalApproval == ApprovalStatus.Approved)
const isRejectedRef = computed(() => inviteRef.value?.dataGroupApproval == ApprovalStatus.Rejected || inviteRef.value?.principalApproval == ApprovalStatus.Rejected)
const canEditRef = computed(() => canSendRef.value || canResendRef.value)
const canSendRef = computed(() => isNewRef.value && !loadingRef.value)
const minResendDateRef = computed(() => inviteRef.value?.lastSentDate?.plus(minResendInterval))
const canResendRef = computed(() => inviteRef.value && !isNewRef.value && isSenderRef.value && 
  inviteRef.value.result == InvitationResult.Pending &&
  minResendDateRef.value &&
  DateTime.utc() >= minResendDateRef.value)
const canCancelRef = computed(() => !isNewRef.value && inviteRef.value?.result == InvitationResult.Pending &&
  (isSenderRef.value ||
  (!isDataGroupApprovedRef.value && isFamilyGroupOwnerRef.value) ||
  (!isPrincipalApprovedRef.value && isDataGroupOwnerRef.value)))
const canApproveRef = computed(() => 
  (!isDataGroupApprovedRef.value && isDataGroupOwnerRef.value) ||
  (!isPrincipalApprovedRef.value && isFamilyGroupOwnerRef.value))
const canRejectRef = computed(() => 
  (inviteRef.value?.dataGroupApproval == ApprovalStatus.Pending && isDataGroupOwnerRef.value) ||
  (inviteRef.value?.principalApproval == ApprovalStatus.Pending && isFamilyGroupOwnerRef.value))
const closeActionTextRef = computed(() => canSendRef.value ? "Cancel" : "Close")

watchEffect(() => {
  if (isNewRef.value) {
    if (dataGroupRef.value && isDataGroupOwnerRef.value) {
      inviteRef.value!.dataGroupApproval = ApprovalStatus.Approved
    }
    if (familyGroupRef.value && isFamilyGroupOwnerRef.value) {
      inviteRef.value!.principalApproval = ApprovalStatus.Approved
    }
  }
})

__expose({
  openNew,
  openEdit,
})

function openNew(dataGroupId: string, familyGroupId: string) {
  const inv = new DataGroupInvite()
  inv.senderUserId = tokenManager.current.userId
  inv.dataGroupId = dataGroupId
  inv.principalType = PrincipalType.FamilyGroup
  inv.principalId = familyGroupId
  inviteRef.value = inv
  busyRef.value = false
  Modal.getOrCreateInstance(modalElemRef.value!)?.show()
}

function openEdit(inviteId: string) {
  inviteRef.value = inviteStore.getAsyncInvite(inviteId)?.data // loaded by parent
  senderMessageRef.value = inviteRef.value?.senderMessage ?? ''
  busyRef.value = false
  Modal.getOrCreateInstance(modalElemRef.value!)?.show()
}

async function sendInvite() {
  try {
    busyRef.value = true
    inviteRef.value!.senderMessage = senderMessageRef.value
    await inviteStore.sendAsync(inviteRef.value!)
    Modal.getOrCreateInstance(modalElemRef.value!)?.hide()
  }
  finally {
    busyRef.value = false    
  }
}

async function resendInvite() {
  try {
    busyRef.value = true
    await inviteStore.resendAsync(inviteRef.value!.id!, senderMessageRef.value)
    Modal.getOrCreateInstance(modalElemRef.value!)?.hide()
  }
  finally {
    busyRef.value = false    
  }
}

async function cancelInvite() {
  try {
    busyRef.value = true
    await inviteStore.cancelAsync(inviteRef.value!.id!)
    Modal.getOrCreateInstance(modalElemRef.value!)?.hide()
  }
  finally {
    busyRef.value = false    
  }
}

async function approveInvite() {
  try {
    busyRef.value = true
    await inviteStore.approveAsync(inviteRef.value!.id!)
    Modal.getOrCreateInstance(modalElemRef.value!)?.hide()
  }
  finally {
    busyRef.value = false
  }
}

async function rejectInvite() {
  try {
    busyRef.value = true
    await inviteStore.rejectAsync(inviteRef.value!.id!)
    Modal.getOrCreateInstance(modalElemRef.value!)?.hide()
  }
  finally {
    busyRef.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalElemRef",
    ref: modalElemRef,
    class: "modal invite-modal",
    "data-bs-backdrop": "static",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(titleRef.value), 1)
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, _toDisplayString(senderUserRef.value?.displayName), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              (isDataGroupApprovedRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(familyGroupOwnerRef.value?.displayName), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(dataGroupOwnerRef.value?.displayName), 1))
            ]),
            (!isNewRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(DateTimeUtil).toUserActionDate(inviteRef.value?.lastSentDate)) + " (" + _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(inviteRef.value?.lastSentDate)) + ") ", 1)
                ]))
              : _createCommentVNode("", true),
            (!isNewRef.value && inviteRef.value?.result != _unref(InvitationResult).Accepted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(DateTimeUtil).toUserActionDate(inviteRef.value?.expirationDate, true)) + " (" + _toDisplayString(_unref(DateTimeUtil).toRelativeDate(inviteRef.value?.expirationDate)) + ") ", 1)
                ]))
              : _createCommentVNode("", true),
            (!isNewRef.value && inviteRef.value?.status != _unref(DataGroupInviteStatus).Pending)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", {
                    class: _normalizeClass(["badge invite-status", inviteRef.value!.status.toLowerCase()])
                  }, [
                    (isDataGroupApprovedRef.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(inviteRef.value!.statusText), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(inviteRef.value!.statusText), 1)
                        ], 64))
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (inviteRef.value?.result == _unref(InvitationResult).Accepted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(DateTimeUtil).toUserActionDate(inviteRef.value?.closedDate, true)) + " (" + _toDisplayString(_unref(DateTimeUtil).toRelativeDate(inviteRef.value?.closedDate)) + ") ", 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (isRejectedRef.value && canApproveRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Even though this request has been declined, you can still approve it until it is either cancelled or expires. "))
            : _createCommentVNode("", true),
          (loadingRef.value)
            ? (_openBlock(), _createBlock(LoadingIndicator, { key: 1 }))
            : (inviteRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (isProfileRef.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", null, _toDisplayString(senderUserRef.value?.displayName) + " would like to make this profile: ", 1),
                        _createElementVNode("div", null, [
                          _createVNode(ProfileCard, {
                            "person-id": dataGroupRef.value?.startItemId,
                            static: ""
                          }, null, 8, ["person-id"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", null, _toDisplayString(senderUserRef.value?.displayName) + " would like to share this tree: ", 1),
                        _createElementVNode("div", null, [
                          _createVNode(ResearchGroupCard, {
                            "data-group-id": inviteRef.value.dataGroupId!,
                            small: "",
                            "select-mode": ""
                          }, null, 8, ["data-group-id"])
                        ])
                      ])),
                  _createElementVNode("div", _hoisted_30, [
                    (isProfileRef.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, " visible to this group: "))
                      : (_openBlock(), _createElementBlock("div", _hoisted_32, " with this group: ")),
                    _createElementVNode("div", null, [
                      _createVNode(FamilyGroupItem, {
                        "family-group-id": inviteRef.value.principalId
                      }, null, 8, ["family-group-id"])
                    ])
                  ]),
                  (senderMessageRef.value || canEditRef.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        (canEditRef.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 0,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((senderMessageRef).value = $event)),
                              class: "form-control"
                            }, null, 512)), [
                              [_vModelText, senderMessageRef.value]
                            ])
                          : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(inviteRef.value.senderMessage), 1))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_36, [
          (canCancelRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-danger secondary-action",
                disabled: busyRef.value,
                onClick: cancelInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Cancelling... ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Cancel request ")
                    ], 64))
              ], 8, _hoisted_37))
            : _createCommentVNode("", true),
          (canRejectRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-outline-danger secondary-action",
                disabled: busyRef.value,
                onClick: rejectInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Declining... ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Decline ")
                    ], 64))
              ], 8, _hoisted_38))
            : _createCommentVNode("", true),
          (canSendRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn btn-primary",
                disabled: busyRef.value,
                onClick: sendInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Sending... ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(SendIcon)),
                      _createTextVNode(" Send ")
                    ], 64))
              ], 8, _hoisted_39))
            : _createCommentVNode("", true),
          (canResendRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "btn btn-primary",
                disabled: busyRef.value,
                onClick: resendInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Resending... ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(SendIcon)),
                      _createTextVNode(" Resend ")
                    ], 64))
              ], 8, _hoisted_40))
            : _createCommentVNode("", true),
          (canApproveRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                type: "button",
                class: "btn btn-primary",
                disabled: busyRef.value,
                onClick: approveInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Approving... ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(CheckIcon)),
                      _createTextVNode(" Approve ")
                    ], 64))
              ], 8, _hoisted_41))
            : _createCommentVNode("", true),
          _createElementVNode("button", _hoisted_42, _toDisplayString(closeActionTextRef.value), 1)
        ])
      ])
    ])
  ], 512))
}
}

})